import { Button, chakra, Box, Flex, Image, Text, Img, useDisclosure } from '@chakra-ui/react';
import React, { useContext } from 'react';
import LogoDashboard from '../../../images/petalas-deovita.svg';
import '../css/main.css';
import { useNavigate } from 'react-router-dom';
import { AccountContext } from '../../AccountContext';
import Carrinho from '../../../images/carrinho.svg';
import DrawerCarrinho from './Carrinho/DrawerCarrinho';
import CircleCart from 'components/AreaLivre/CircleCart';
import { MdCircleNotifications, MdKeyboardArrowLeft } from 'react-icons/md';
import { ArrowBackIcon } from '@chakra-ui/icons';
import ModalNotificacao from '../ButtonNotificacao/ModalNotificacao/ModalNotificacao';
import { IoNotificationsOutline } from 'react-icons/io5';

function ChildHeader(props) {
  const navigate = useNavigate();
  const { user, page } = useContext(AccountContext);
  const { id_contrato, descricao_plano, titular } = user;

  const backgroundColor =
    titular === true && id_contrato === 0
      ? '#5AB2AE'
      : titular === false && id_contrato === 0
        ? '#5AB2AE'
        : titular === true && id_contrato > 0
          ? '#5AB2AE'
          : '#5AB2AE';

  let message =
    id_contrato && descricao_plano
      ? `Assinante plano ${String(descricao_plano).charAt(0).toUpperCase() + String(descricao_plano).slice(1).toLowerCase()}`
      : 'Assine agora!';
  if (titular === false) message = 'Assinante dependente';
  if (user.situacao_contrato === 'P') message = 'Contrato em análise';

  const disclosureCarrinho = useDisclosure();
  const disclosureNotificacao = useDisclosure();
  let firstName = user.name.split(' ');
  let url = window.location.href;

  return (
    <>
      <DrawerCarrinho disclosure={disclosureCarrinho} />
      <ModalNotificacao disclosure={disclosureNotificacao} notificacoes_sns={user.cache_notificacao} />

      <chakra.header w="full" py={0} shadow="md" backgroundColor={backgroundColor} minHeight="136px" borderBottomRadius="30px">
        <Flex alignItems="center" justifyContent="space-between" mx="auto" ml={{ sm: '40px', base: '10px' }} position="relative">
          <Flex direction="column">
            <chakra.h2 fontSize="1em" fontWeight="bold" mt="43px" color="white">
              Este é seu app de saúde
            </chakra.h2>

            <Button
              fontSize="12px"
              minH="20px"
              h="auto"
              px={3}
              py={1}
              maxW="100%"
              whiteSpace="normal"
              wordBreak="break-word"
              textAlign="center"
              lineHeight="1.2"
              color={backgroundColor}
              borderRadius={20}
              onClick={() => {
                if (message === 'Assine agora!') {
                  navigate('/cadastro/plano');
                }
              }}
            >
              {message}
            </Button>
          </Flex>

          <Flex direction="column" alignItems="center" position="absolute" right="0.5rem" top="35px" gap="6px">
            <Image w="70px" h="55px" src={LogoDashboard} alt="Logo" />

            <Box position="relative" cursor="pointer" onClick={() => disclosureNotificacao.onOpen()}>
              <IoNotificationsOutline color="#FFF" size={24} />

              {user?.cache_notificacao?.some((n) => !n.lida) && (
                <Box position="absolute" top="-4px" right="-4px" bg="red.500" borderRadius="full" w="10px" h="10px" />
              )}
            </Box>
          </Flex>
        </Flex>

        <Flex direction="row" justifyContent="space-between" alignItems="center" mt="10px">
          <Box
            ml={8}
            onClick={() => {
              props?.home ? navigate('/dashboard') : navigate(-1);
            }}
          >
            <ArrowBackIcon color="#FFF" size={40} />
          </Box>

          <Text fontSize="1em" fontWeight="bold" textColor="white" textAlign="center" width="100%" zIndex="1">
            {props?.page ? props?.page : page}
          </Text>

          {url.includes('/exames/agendamento') || url.includes('/exames/empresa') ? (
            <>
              <Img
                backgroundColor="#FFF"
                src={Carrinho}
                borderRadius={15}
                w="45px"
                h="25px"
                padding={1}
                onClick={() => disclosureCarrinho.onOpen()}
                color="orange"
                zIndex="101"
                mr={7}
              />

              {user.cart && user.cart.itens ? <CircleCart quantidade={user.cart.itens.length} /> : null}
            </>
          ) : (
            <Box mr={7} />
          )}
        </Flex>
      </chakra.header>
    </>
  );
}

export default ChildHeader;
